import axios from 'axios';
import store from '@/store'

const baseURL = process.env.VUE_APP_ENGINE_URL;

const apiUsername = process.env.VUE_APP_ENGINE_API_USER;
const apiPassword = process.env.VUE_APP_ENGINE_API_PASS;
const apiToken = Buffer.from(`${apiUsername}:${apiPassword}`, 'utf8').toString('base64');

const state = {
  allDbTables: [],
  addedTable: '',
  updatedTable: '',
  deletedTable: '',
  tablePages: 0,
  tableRows: 0,
  tableHeaders: [],
  tableData: [],
  tableId: 0,
  tableName: '',
  addedRow: '',
  editedRow: '',
  deletedRow: '',
  sqlData: [],
  mappedSqlData: [],
  errorMessage: '',
  runScript: false,
  qCount: 0,
  exportedTableData: [],
  checkTableExists: false,
  importDataSaved: false,
  promoteRes: [],
  starterVarsSaved: false,
  starterVars: ''
};

const getters = {
  allDbTables: (state) => state.allDbTables,
  tableHeaders: (state) => state.tableHeaders,
  tablePages: (state) => state.tablePages,
  tableRows: (state) => state.tableRows,
  tableData: (state) => state.tableData,
  tableId: (state) => state.tableId,
  tableName: (state) => state.tableName,
  sqlData: (state) => state.sqlData,
  mappedSqlData: (state) => state.mappedSqlData,
  errorMessage: (state) => state.errorMessage,
  qCount: (state) => state.qCount,
  exportedTableData: (state) => state.exportedTableData,
  checkTableExists: (state) => state.checkTableExists,
  promoteRes: (state) => state.promoteRes,
  starterVarsSaved: (state) => state.starterVarsSaved,
  starterVars: (state) => state.starterVars
};

const actions = {
  getAllTables({commit}) {
    let data = {
      'variables': {
        'requestType': { 'value': 'getAll', 'type': 'String' }
      },
      'withVariablesInReturn': true
    };
    
    return axios.post(baseURL + '/process-definition/key/databaseController/start', data, {headers: {'Content-Type': 'application/json', 'Authorization': 'Basic ' + store.state.token}}).then( result => {      
      commit('ALL_TABLES', JSON.parse(result.data.variables.tables.value));
    }).catch(error => {
      let msg = 'Possible error in SQL statement. ' + error;
      commit('ERROR_MESSAGE', msg);
    });
  },
  createTable({commit}, payload) {
    let data = {
      'variables': {
        'requestType': { 'value': 'create', 'type': 'String' },
        'tableName': { 'value': payload.tableName, 'type': 'String' },
        'createdBy': { 'value': store.state.currentUser, 'type': 'String' },
        'tableData': { 'value': payload.tableData, 'type': 'Json' }
      }
    };
    
    return axios.post(baseURL + '/process-definition/key/databaseController/start', data, {headers: {'Content-Type': 'application/json', 'Authorization': 'Basic ' + store.state.token}}).then( () => {      
      commit('ADDED_TABLE', payload.tableName);
    }).catch(error => {
      let msg = 'Possible error in table field names (e.g. invalid use of reserved word). ' + error;
      commit('ERROR_MESSAGE', msg);
    });
  },
  updateTable({commit}, payload) {
    let data = {
      'variables': {
        'requestType': { 'value': 'update', 'type': 'String' },
        'tableName': { 'value': payload.tableName, 'type': 'String' },
        'updatedBy': { 'value': store.state.currentUser, 'type': 'String' },
        'tableData': { 'value': payload.tableData, 'type': 'Json' },
        'editData': { 'value': payload.editData, 'type': 'Json' }
      }
    };
    
    return axios.post(baseURL + '/process-definition/key/databaseController/start', data, {headers: {'Content-Type': 'application/json', 'Authorization': 'Basic ' + store.state.token}}).then( () => {      
      commit('UPDATED_TABLE', payload.tableName);
    }).catch(error => {
      let msg = 'Possible error in SQL statement. ' + error;
      commit('ERROR_MESSAGE', msg);
    });
  },
  deleteTable({commit}, payload) {
    let data = {
      'variables': {
        'requestType': { 'value': 'deleteTable', 'type': 'String' },
        'tableName': { 'value': payload.tableName, 'type': 'String' },
        'tableId': { 'value': payload.tableId, 'type': 'Integer' }
      }
    };
    
    return axios.post(baseURL + '/process-definition/key/databaseController/start', data, {headers: {'Content-Type': 'application/json', 'Authorization': 'Basic ' + store.state.token}}).then( () => {      
      commit('DELETED_TABLE', payload.tableName);
    }).catch(error => {
      let msg = 'Possible error in SQL statement. ' + error;
      commit('ERROR_MESSAGE', msg);
    });
  },
  viewTable({commit}, tableId) {
    let data = {
      'variables': {
        'requestType': { 'value': 'getData', 'type': 'String' },
        'tableId': { 'value': tableId, 'type': 'Integer' },
        'pagination': { 'value': false, 'type': 'Boolean' }
      },
      'withVariablesInReturn': true
    };
    
    return axios.post(baseURL + '/process-definition/key/databaseController/start', data, {headers: {'Content-Type': 'application/json', 'Authorization': 'Basic ' + store.state.token}}).then( result => {      

      let headers = JSON.parse(result.data.variables.headers.value);
      let tData = JSON.parse(result.data.variables.tableData.value);

      for(let i = 0; i < headers.length; i++) {
        if(headers[i].fieldType == 'Date' || headers[i].fieldType == 'DateTime') {
          for(let j = 0; j < tData.length; j++) {
            let keys = Object.keys(tData[j]);

            keys.forEach((key) => {
              if(headers[i].fieldName == key) {
                let dateObj = null;
                let converted = '';
                
                if(headers[i].fieldType == 'Date') {
                  dateObj = new Date(tData[j][key]);
                  converted = dateObj.getFullYear() + '-' + ("0" + (dateObj.getMonth() + 1)).slice(-2) + '-' + ("0" + dateObj.getDate()).slice(-2);
                }
                
                if(headers[i].fieldType == 'DateTime') {
                  dateObj = tData[j][key];
                  converted = dateObj.year + '-' + ("0" + dateObj.monthValue).slice(-2) + '-' + ("0" + dateObj.dayOfMonth).slice(-2) + ' ' + ("0" + dateObj.hour).slice(-2) + ':' + ("0" + dateObj.minute).slice(-2) + ':' + ("0" + dateObj.second).slice(-2);
                }
                tData[j][key] = converted;
              }
            });
          }
        }
      }

      commit('TABLE_HEADERS', headers);
      commit('TABLE_DATA', tData);
    }).catch(error => {
      let msg = 'Possible error in SQL statement. ' + error;
      commit('ERROR_MESSAGE', msg);
    });
  },
  viewPaginatedTable({commit}, payload) {
    let data = {
      'variables': {
        'requestType': { 'value': 'getData', 'type': 'String' },
        'tableId': { 'value': payload.tableId, 'type': 'Integer' },
        'pagination': { 'value': true, 'type': 'Boolean' },
        'offset': { 'value': payload.offset, 'type': 'Integer' },
        'orderBy': { 'value': payload.orderBy, 'type': 'String' },
        'pageSize': { 'value': payload.pageSize, 'type': 'Integer' }
      },
      'withVariablesInReturn': true
    };
    
    return axios.post(baseURL + '/process-definition/key/databaseController/start', data, {headers: {'Content-Type': 'application/json', 'Authorization': 'Basic ' + store.state.token}}).then( result => {      

      let headers = JSON.parse(result.data.variables.headers.value);
      let tData = JSON.parse(result.data.variables.tableData.value);

      for(let i = 0; i < headers.length; i++) {
        if(headers[i].fieldType == 'Date' || headers[i].fieldType == 'DateTime') {
          for(let j = 0; j < tData.length; j++) {
            let keys = Object.keys(tData[j]);

            keys.forEach((key) => {
              if(headers[i].fieldName == key) {
                let dateObj = null;
                let converted = '';
                
                if(tData[j][key]) {
                  if(headers[i].fieldType == 'Date') {
                    dateObj = new Date(tData[j][key]);
                    converted = dateObj.getFullYear() + '-' + ("0" + (dateObj.getMonth() + 1)).slice(-2) + '-' + ("0" + dateObj.getDate()).slice(-2);
                  }
                  
                  if(headers[i].fieldType == 'DateTime') {
                    dateObj = tData[j][key];
                    converted = dateObj.year + '-' + ("0" + dateObj.monthValue).slice(-2) + '-' + ("0" + dateObj.dayOfMonth).slice(-2) + ' ' + ("0" + dateObj.hour).slice(-2) + ':' + ("0" + dateObj.minute).slice(-2) + ':' + ("0" + dateObj.second).slice(-2);
                  }
                }
                tData[j][key] = converted;
              }
            });
          }
        }
      }

      commit('TABLE_PAGES', result.data.variables.totalPages.value);
      commit('TABLE_ROWS', result.data.variables.totalRows.value);
      commit('TABLE_HEADERS', headers);
      commit('TABLE_DATA', tData);
    }).catch(error => {
      let msg = 'Possible error in SQL statement. ' + error;
      commit('ERROR_MESSAGE', msg);
    });
  },
  addTableRow({commit}, payload) {
    let data = {
      'variables': {
        'requestType': { 'value': 'saveData', 'type': 'String' },
        'action': { 'value': 'add', 'type': 'String' },
        'tableName': { 'value': payload.tableName, 'type': 'String' },
        'rowData': { 'value': payload.rowData, 'type': 'Json' }
      }
    };
    
    return axios.post(baseURL + '/process-definition/key/databaseController/start', data, {headers: {'Content-Type': 'application/json', 'Authorization': 'Basic ' + store.state.token}}).then( () => {      
      commit('ADDED_ROW', 'success');
    }).catch(error => {
      let msg = 'Possible error in SQL statement. ' + error;
      commit('ERROR_MESSAGE', msg);
    });
  },
  editTableRow({commit}, payload) {
    let data = {
      'variables': {
        'requestType': { 'value': 'saveData', 'type': 'String' },
        'action': { 'value': 'edit', 'type': 'String' },
        'tableName': { 'value': payload.tableName, 'type': 'String' },
        'rowId': { 'value': payload.rowId, 'type': 'Integer' },
        'rowData': { 'value': payload.rowData, 'type': 'Json' }
      }
    };
    
    return axios.post(baseURL + '/process-definition/key/databaseController/start', data, {headers: {'Content-Type': 'application/json', 'Authorization': 'Basic ' + store.state.token}}).then( () => {      
      commit('EDITED_ROW', 'success');
    }).catch(error => {
      let msg = 'Possible error in SQL statement. ' + error;
      commit('ERROR_MESSAGE', msg);
    });
  },
  deleteTableRow({commit}, payload) {
    let data = {
      'variables': {
        'requestType': { 'value': 'deleteData', 'type': 'String' },
        'tableName': { 'value': payload.tableName, 'type': 'String' },
        'rowId': { 'value': payload.rowId, 'type': 'Integer' }
      }
    };
    
    return axios.post(baseURL + '/process-definition/key/databaseController/start', data, {headers: {'Content-Type': 'application/json', 'Authorization': 'Basic ' + store.state.token}}).then( () => {      
      commit('DELETED_ROW', 'success');
    }).catch(error => {
      let msg = 'Possible error in SQL statement. ' + error;
      commit('ERROR_MESSAGE', msg);
    });
  },
  // Select executions only
  executeSql({commit, state}, payload) {
    let data = {
      'variables': {
        'requestType': { 'value': 'getSqlData', 'type': 'String' },
        'connId': { 'value': payload.connId, 'type': 'Integer' },
        'theSql': { 'value': payload.theSql, 'type': 'String' },
        'mappedVar': { 'value': payload.mappedVar, 'type': 'String' }
      },
      'withVariablesInReturn': true
    };

    return axios.post(baseURL + '/process-definition/key/databaseController/start', data, {headers: {'Content-Type': 'application/json', 'Authorization': 'Basic ' + store.state.token}}).then( result => {      
      
      if(result.data.variables.sqlData) {
        commit('SQL_DATA', JSON.parse(result.data.variables.sqlData.value));
      }else {
        let keys = Object.keys(result.data.variables);

        keys.forEach((key) => {
          if(key == payload.mappedVar) {
            commit('MAPPED_SQL_DATA', JSON.parse(result.data.variables[key].value));
          }
        });        
      }
      commit('Q_COUNT', state.qCount + 1);
      commit('RUN_SCRIPT', true);
    }).catch(error => {
      if(error != 'TypeError: data is null') {
        let msg = 'Possible error in SQL statement. ' + error;
        commit('ERROR_MESSAGE', msg);
      }
    });
  },
  // All other execution types
  executeSqlOther({commit, state}, payload) {
    let data = {
      'variables': {
        'requestType': { 'value': 'setSqlData', 'type': 'String' },
        'connId': { 'value': payload.connId, 'type': 'Integer' },
        'theSql': { 'value': payload.theSql, 'type': 'String' }
      }
    };
    
    return axios.post(baseURL + '/process-definition/key/databaseController/start', data, {headers: {'Content-Type': 'application/json', 'Authorization': 'Basic ' + store.state.token}}).then( () => {      
       commit('SQL_DATA', '');
       commit('Q_COUNT', state.qCount + 1);
       commit('RUN_SCRIPT', true);
    }).catch(error => {
      if(error != 'TypeError: data is null') {
        let msg = 'Possible error in SQL statement. ' + error;
        commit('ERROR_MESSAGE', msg);
      }
    });
  },
  // External select executions only
  executeExternalSql({commit, state}, payload) {
    let data = {
      'variables': {
        'requestType': { 'value': 'getSqlData', 'type': 'String' },
        'connId': { 'value': payload.connId, 'type': 'Integer' },
        'theSql': { 'value': payload.theSql, 'type': 'String' },
        'mappedVar': { 'value': payload.mappedVar, 'type': 'String' }
      },
      'withVariablesInReturn': true
    };

    return axios.post(baseURL + '/process-definition/key/databaseController/start', data, {headers: {'Content-Type': 'application/json', 'Authorization': 'Basic ' + apiToken}}).then( result => {      
      
      if(result.data.variables.sqlData) {
        commit('SQL_DATA', JSON.parse(result.data.variables.sqlData.value));
      }else {
        let keys = Object.keys(result.data.variables);

        keys.forEach((key) => {
          if(key == payload.mappedVar) {
            commit('MAPPED_SQL_DATA', JSON.parse(result.data.variables[key].value));
          }
        });        
      }
      commit('Q_COUNT', state.qCount + 1);
      commit('RUN_SCRIPT', true);
    }).catch(error => {
      if(error != 'TypeError: data is null') {
        let msg = 'Possible error in SQL statement. ' + error;
        commit('ERROR_MESSAGE', msg);
      }
    });
  },
  // All other external execution types
  executeExternalSqlOther({commit, state}, payload) {
    let data = {
      'variables': {
        'requestType': { 'value': 'setSqlData', 'type': 'String' },
        'connId': { 'value': payload.connId, 'type': 'Integer' },
        'theSql': { 'value': payload.theSql, 'type': 'String' }
      }
    };
    
    return axios.post(baseURL + '/process-definition/key/databaseController/start', data, {headers: {'Content-Type': 'application/json', 'Authorization': 'Basic ' + apiToken}}).then( () => {      
       commit('SQL_DATA', '');
       commit('Q_COUNT', state.qCount + 1);
       commit('RUN_SCRIPT', true);
    }).catch(error => {
      if(error != 'TypeError: data is null') {
        let msg = 'Possible error in SQL statement. ' + error;
        commit('ERROR_MESSAGE', msg);
      }
    });
  },
  getStarterVars({commit}, processKey) {
    let data = {
      'variables': {
        'requestType': { 'value': 'getStarterVars', 'type': 'String' },
        'processKey': { 'value': processKey, 'type': 'String' }
      },
      'withVariablesInReturn': true
    };
    
    return axios.post(baseURL + '/process-definition/key/databaseController/start', data, {headers: {'Content-Type': 'application/json', 'Authorization': 'Basic ' + store.state.token}}).then( result => {      
       commit('STARTER_VARS', result.data.variables.starterVars);
    }).catch(error => {
      if(error != 'TypeError: data is null') {
        let msg = 'Possible error in SQL statement. ' + error;
        commit('ERROR_MESSAGE', msg);
      }
    });
  },
  setStarterVars({commit}, payload) {
    let data = {
      'variables': {
        'requestType': { 'value': 'setStarterVars', 'type': 'String' },
        'connId': { 'value': payload.connId, 'type': 'Integer' },
        'processKey': { 'value': payload.processKey, 'type': 'String' },
        'starterVars': { 'value': payload.starterVars, 'type': 'String' }
      },
      'withVariablesInReturn': true
    };
    
    return axios.post(baseURL + '/process-definition/key/databaseController/start', data, {headers: {'Content-Type': 'application/json', 'Authorization': 'Basic ' + store.state.token}}).then( result => {      
       commit('STARTER_VARS_SAVED', result.data.variables.varsSaved);
    }).catch(error => {
      if(error != 'TypeError: data is null') {
        let msg = 'Possible error in SQL statement. ' + error;
        commit('ERROR_MESSAGE', msg);
      }
    });
  },
  exportTables({commit}, payload) {
    let data = {
      'variables': {
        'requestType': { 'value': 'export', 'type': 'String' },
        'exportTableData': { 'value': payload.exports, 'type': 'Json' }
      },
      'withVariablesInReturn': true
    };
    
    return axios.post(baseURL + '/process-definition/key/databaseController/start', data, {headers: {'Content-Type': 'application/json', 'Authorization': 'Basic ' + store.state.token}}).then( result => {      
      let exportData = [];
      for(let i = 0; i < payload.count; i++) {
        let name = 'fileName' + i;
        let buffer = 'fileBuffer' + i;
        let fileName = result.data.variables[name].value;
        let fileData = result.data.variables[buffer].value;
        let mimeType = 'application/octet-stream';

        const byteCharacters = atob(fileData);
        const byteNumbers = new Array(byteCharacters.length);
        for (let i = 0; i < byteCharacters.length; i++) {
          byteNumbers[i] = byteCharacters.charCodeAt(i);
        }
        const byteArray = new Uint8Array(byteNumbers);
        let blob = new Blob([byteArray], {type: mimeType});
        let url = window.URL.createObjectURL(blob);

        exportData.push({ fileName: fileName, fileData: url });
      }
      commit('EXPORTED_TABLE_DATA', exportData);
    }).catch(error => {
      if(error != 'TypeError: data is null') {
        let msg = 'Possible error in SQL statement. ' + error;
        commit('ERROR_MESSAGE', msg);
      }
    });
  },
  checkTable({commit}, tableName) {
    let data = {
      'variables': {
        'requestType': { 'value': 'checkTable', 'type': 'String' },
        'tableName': { 'value': tableName, 'type': 'String' }
      },
      'withVariablesInReturn': true
    };

    return axios.post(baseURL + '/process-definition/key/databaseController/start', data, {headers: {'Content-Type': 'application/json', 'Authorization': 'Basic ' + store.state.token}}).then( result => {      
      let tableExists = result.data.variables.tableExists.value;
      commit('CHECK_TABLE_EXISTS', tableExists);
    }).catch(error => {
      commit('ERROR_MESSAGE', error);
    });
  },
  importTable({commit}, payload) {
    let data = {
      'variables': {
        'requestType': { 'value': 'import', 'type': 'String' },
        'tableName': { 'value': payload.tableName, 'type': 'String' },
        'filename': { 'value': payload.name, 'type': 'String' },
        'createdBy': { 'value': store.state.currentUser, 'type': 'String' },
        'fileData': { 'value': payload.fileData, 'type': 'File', 'valueInfo': { 'filename': payload.name, 'mimetype': payload.mimeType, 'encoding': 'UTF-8' } }
      }
    };
    
    return axios.post(baseURL + '/process-definition/key/databaseController/start', data, {headers: {'Content-Type': 'application/json', 'Authorization': 'Basic ' + store.state.token}}).then( () => {      
      // Force a 1 second wait for local storage
      setTimeout(function(){
        commit('IMPORT_DATA_SAVED', true);
      }, 1000);
    }).catch(error => {
      if(error != 'TypeError: data is null') {
        let msg = 'Possible error in SQL statement. ' + error;
        commit('ERROR_MESSAGE', msg);
      }
    });
  },
  promoteTables({commit}, payload) {
    let promoteRes = [];

    let data = {
      'variables': {
        'requestType': { 'value': 'promote', 'type': 'String' },
        'promoteTableData': { 'value': payload.promotes, 'type': 'Json' },
        'action': { 'value': 'check', 'type': 'String' },
      },
      'withVariablesInReturn': true
    };
    return axios.post(payload.engine + '/engine-rest/process-definition/key/databaseController/start', data, {headers: {'Content-Type': 'application/json', 'Authorization': 'Basic ' + store.state.token}}).then( result => {      
      let tableExists = JSON.parse(result.data.variables.tableExists.value);
      let promoteInfo = JSON.parse(payload.promotes);
      let promoteData = [];
      const PromiseArr = [];

      for(let i = 0; i < tableExists.length; i++) {
        const tableKeys = Object.keys(tableExists[i]);

        tableKeys.forEach((key) => {
          if(!tableExists[i][key]) {
            for(let j = 0; j < promoteInfo.length; j++) {
              if(promoteInfo[j].tableName == key) {
                promoteData.push({ tableName: promoteInfo[j].tableName, exportData: promoteInfo[j].exportData });
              }
            }
          }else {
            promoteRes.push({ tableName: key, promoted: false, result: 'Table ' + key + ' already exists and will not be altered.'});
          }
        });
      }

      let data = {
        'variables': {
          'requestType': { 'value': 'promote', 'type': 'String' },
          'promoteTableData': { 'value': JSON.stringify(promoteData), 'type': 'Json' },
          'action': { 'value': 'get', 'type': 'String' },
        },
        'withVariablesInReturn': true
      };

      PromiseArr.push(
        axios.post(baseURL + '/process-definition/key/databaseController/start', data, {headers: {'Content-Type': 'application/json', 'Authorization': 'Basic ' + store.state.token}}).then( result => new Promise(resolve => 
          resolve(result.data.variables)))
      );
      
      Promise.all(PromiseArr).then(res => {

        res.forEach(function(item) {
          const PromiseArr2 = [];
          let createTables = [];
          let existingData = [];

          if(typeof item.promoteTable !== 'undefined') {
            createTables = JSON.parse(item.promoteTable.value);
          }

          if(typeof item.existingData !== 'undefined') {
            existingData = JSON.parse(item.existingData.value);
          }

          let createSql = '';
          let insertData = false;
          let insertSql = '';
          let tableData = '';
          let tName = '';
          
          for(let k = 0; k < createTables.length; k++) {
            createSql = createTables[k]['Create Table'];

            for(let l = 0; l < payload.tables.length; l++) {
              tName = payload.tables[l];

              if('HAR_' + tName == createTables[k]['Table']) {
                if(typeof item[tName] !== 'undefined') {
                  insertData = true;
                  insertSql = item[tName].value;
                }
                break;
              }
            }

            for(let m = 0; m < existingData.length; m++) {
              if(tName == existingData[m].TABLE_NAME) {
                tableData = existingData[m].TABLE_DATA;
                break;
              }
            }

            let data = {
              'variables': {
                'requestType': { 'value': 'promote', 'type': 'String' },
                'action': { 'value': 'create', 'type': 'String' },
                'createSql': { 'value': createSql, 'type': 'String' },
                'insertData': { 'value': insertData, 'type': 'Boolean' },
                'insertSql': { 'value': insertSql, 'type': 'String' },
                'tableName': { 'value': tName, 'type': 'String' },
                'createdBy': { 'value': store.state.currentUser, 'type': 'String' },
                'tableData': { 'value': tableData, 'type': 'Json' }
              },
              'withVariablesInReturn': true
            };

            PromiseArr2.push(
              axios.post(payload.engine + '/engine-rest/process-definition/key/databaseController/start', data, {headers: {'Content-Type': 'application/json', 'Authorization': 'Basic ' + store.state.token}}).then( result => new Promise(resolve => 
                resolve(result)))
            );
          }

          Promise.all(PromiseArr2).then(res => {

            res.forEach(function(item) {
              if(item.status == 200) {
                let reqData = JSON.parse(item.request.response);
                let tableName = reqData.variables.tableName.value;
                let populated = reqData.variables.insertData.value;
                let update = '';

                if(populated) {
                  update = 'Table ' + tableName + ' has been created and populated.';
                }else {
                  update = 'Table ' + tableName + ' has been created.';
                }

                promoteRes.push({ tableName: tableName, promoted: true, result: update });
              }
            });
            commit('PROMOTE_RES', promoteRes);
          });

          if(createTables.length == 0) {
            commit('PROMOTE_RES', promoteRes);
          }

        });

      });

    }).catch(error => {
      if(error != 'TypeError: data is null') {
        let msg = 'Unable to check remote tables. ' + error;
        commit('ERROR_MESSAGE', msg);
      }
    });
  },
};

const mutations = {
  ALL_TABLES(state, payload) {
    state.allDbTables = payload;
  },
  ADDED_TABLE(state, payload) {
    state.addedTable = payload;
  },
  UPDATED_TABLE(state, payload) {
    state.updatedTable = payload;
  },
  DELETED_TABLE(state, payload) {
    state.deletedTable = payload;
  },
  TABLE_PAGES(state, payload) {
    state.tablePages = payload;
  },
  TABLE_ROWS(state, payload) {
    state.tableRows = payload;
  },
  TABLE_HEADERS(state, payload) {
    state.tableHeaders = payload;
  },
  TABLE_DATA(state, payload) {
    state.tableData = payload;
  },
  UPDATE_TABLE_ID(state, payload) {
    state.tableId = payload;
  },
  UPDATE_TABLE_NAME(state, payload) {
    state.tableName = payload;
  },
  ADDED_ROW(state, payload) {
    state.addedRow = payload;
  },
  EDITED_ROW(state, payload) {
    state.editedRow = payload;
  },
  DELETED_ROW(state, payload) {
    state.deletedRow = payload;
  },
  SQL_DATA(state, payload) {
    state.sqlData = payload;
  },
  MAPPED_SQL_DATA(state, payload) {
    state.mappedSqlData = payload;
  },
  ERROR_MESSAGE(state, payload) {
    state.errorMessage = payload;
  },
  RUN_SCRIPT(state, payload) {
    state.runScript = payload;
  },
  Q_COUNT(state, payload) {
    state.qCount = payload;
  },
  EXPORTED_TABLE_DATA(state, payload) {
    state.exportedTableData = payload;
  },
  CHECK_TABLE_EXISTS(state, payload) {
    state.checkTableExists = payload;
  },
  IMPORT_DATA_SAVED(state, payload) {
    state.importDataSaved = payload;
  },
  PROMOTE_RES(state, payload) {
    state.promoteRes = payload;
  },
  STARTER_VARS_SAVED(state, payload) {
    state.starterVarsSaved = payload;
  },
  STARTER_VARS(state, payload) {
    state.starterVars = payload;
  }
};

export default {
  state,
  getters,
  actions,
  mutations
}